module.exports = __webpack_public_path__ + "static/media/traffic-lamp-mobile.000a5cb5.svg";